type HttpError = {
  response?: {
    status?: unknown;
  };
  status_code?: unknown;
};

const getHttpStatus = (error: unknown): number | undefined => {
  if (!error || typeof error !== "object") {
    return undefined;
  }

  const candidate = error as HttpError;
  const status = candidate.response?.status ?? candidate.status_code;

  return typeof status === "number" ? status : undefined;
};

/**
 * Busy or unreachable server. The backend answers 503 when its database pool is briefly full, so
 * these clear on their own; without retries one blip shows "Couldn't load your workspaces".
 */
const TRANSIENT_SERVER_STATUSES = new Set([502, 503, 504]);
const TRANSIENT_SERVER_RETRIES = 2;

export const sessionQueryRetry = (failureCount: number, error: unknown): boolean => {
  const status = getHttpStatus(error);

  if (typeof status === "number" && TRANSIENT_SERVER_STATUSES.has(status)) {
    return failureCount < TRANSIENT_SERVER_RETRIES;
  }

  if (typeof status === "number" && status >= 400) {
    return false;
  }

  return failureCount < 1;
};
